<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />
            <td>
              {{
                item.created_at
                  | moment(
                    'timezone',
                    currentUser.active_project.timezone,
                    'MM/DD/YY h:mm A'
                  )
              }}
            </td>
            <td>
              <router-link :to="`/widgets/submission-contents/${item.id}/edit`">
                {{ item.title }}
              </router-link>
            </td>

            <td class="text-center nowrap w0">
              <Actions
                hide-duplicate
                :path="`/widgets/submission-contents/${item.id}`"
                @destroy="$emit('destroy', item)"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sentList: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Type#',
          align: 'start',
          value: 'notification_type',
        },
        {
          text: 'Created at',
          align: 'start',
          value: 'created_at',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        {
          align: 'center',
          sortable: false,
        },
      ];
    },
  },
};
</script>
